import React from 'react';

import stripTags from 'striptags';

import { FormControl } from '~/native-ui/FormControl';
import { RichTextEditor } from '../../RichTextEditor';

export class WysiwygField extends React.PureComponent {
    static propTypes = {};

    state = {
        focused: false,
        hasFocused: false,
    };

    _editor = React.createRef();

    handleChange = (value) => {
        let strippedValue = stripTags(value);
        if (!strippedValue.length) {
            return this.props.onChange('');
        }

        this.props.onChange(value);
    };

    renderEditor = () => {
        return (
            <FormControl>
                {this.props.title && <FormControl.Label label={this.props.title} tooltip={this.props.tooltip} />}
                <RichTextEditor
                    isReadonly={this.props.isReadonly}
                    value={this.props.value}
                    onChange={this.handleChange}
                />
            </FormControl>
        );
    };

    render() {
        return this.renderEditor();
    }
}
